<template>
  <div>
    <!-- <div class="h-title-con">
      <div class="h-title">
        <span class="title-text">{{title}}</span>
      </div>
      <div class="h-button-warpper">
        <span class="orgBtn" @click="save('ruleForm')">保存</span>
        <span class="orgBtn" @click="back()">取消</span>
      </div>
    </div>-->
    <form-header :pageTitle="title" @save="save('ruleForm')" style="margin: 0 20px;"></form-header>
    <div class="white-bg-radius">
      <div class="rolemanage w-label">
        <div class="card">
          <div class="cangbieItem" v-if="isGetData">
            <el-form ref="ruleForm" :model="formData" :rules="rules" label-width="200px">
              <el-form-item label="系统：" prop="systemItem">
                <el-select
                  v-if="!isUpdate"
                  v-model="formData.systemItem"
                  value-key="id"
                  :disabled="isUpdate"
                  placeholder="请选择系统"
                  clearable
                  @change="getGroupNumberList(formData.systemItem)" @blur="blur(formData.systemItem)"
                >
                  <el-option
                    v-for="(item1,index) in branchOffice"
                    :key="index"
                    :label="item1.code + ' ' + item1.name"
                    :value="item1"
                  ></el-option>
                </el-select>
                <el-input v-else v-model="formData.systemItem.name" readonly :disabled="isUpdate"></el-input>
              </el-form-item>
              <el-form-item label="匹配组序号：" prop="groupNumber">
                <el-select
                  v-if="!isUpdate"
                  v-model="formData.groupNumber"
                  placeholder="请选择匹配组序号"
                  clearable
                  @change="selectSortBlur"
                  @blur="selectSortBlur"
                  :disabled="isUpdate"
                >
                  <el-option
                    v-for="(item1,index) in groupNumberGroup"
                    :key="index"
                    :label="item1"
                    :value="item1"
                  ></el-option>
                </el-select>
                <el-input v-else v-model="formData.groupNumber" readonly :disabled="isUpdate"></el-input>
              </el-form-item>
              <el-form-item  class="ww-input-dia" label="物料代号：" prop="kaMaterielCode">
                <el-input
                  suffix-icon="el-icon-tickets"
                  v-model="formData.kaMaterielCode.code"
                  @focus="showDialog($event, 'kaMaterielCode')"
                  :disabled="isUpdate"
                  readonly
                >
                  <i v-if="!isUpdate && formData.kaMaterielCode.name" class="el-icon-error"  slot="append" @click.stop.prevent="clear('kaMaterielCode')"></i>
                </el-input>
                <!--<span v-show="!isUpdate && formData.kaMaterielCode.name" class="clear-btn-wrapper">-->
                  <!--<el-button type="primary" @click="clear('kaMaterielCode')">清空</el-button>-->
                <!--</span>-->
              </el-form-item>
              <el-form-item label="物料名称：">
                <!--<el-input :disabled="!!ruleForm.id" v-model="ruleForm.prodNo" placeholder="达能物料编码" readonly></el-input>-->
                <span class="noBorderText">{{formData.kaMaterielCode.name}}</span>
              </el-form-item>

              <el-form-item label="产品大类代号：">
                <!--<el-input v-model="formData.productBigClassName" readonly :disabled="isUpdate"></el-input>-->
                <span class="noBorderText">{{formData.productBigClassCode}}</span>
              </el-form-item>
              <el-form-item label="产品大类名称：">
                <!--<el-input v-model="formData.productBigClassName" readonly :disabled="isUpdate"></el-input>-->
                 <span class="noBorderText">{{formData.productBigClassName}}</span>
              </el-form-item>

              <el-form-item label="保质期天数：">
                <!--<el-input v-model="formData.shelfLifeDay" readonly :disabled="isUpdate"></el-input>-->
                <span class="noBorderText">{{formData.shelfLifeDay}}</span>
              </el-form-item>
              <el-form-item label="是否共卖品项：" class="otherWidth">
                <span class="noBorderText">{{formData.isCoSale}}</span>

                <!--<el-radio-group v-model="formData.isCoSale" disabled>-->
                  <!--<el-radio label="Y"></el-radio>-->
                  <!--<el-radio label="N"></el-radio>-->
                <!--</el-radio-group>-->
              </el-form-item>
              <el-form-item label="是否工厂代发货：" class="otherWidth">
                <span class="noBorderText">{{formData.isFactoryDelivery}}</span>
                <!--<el-radio-group v-model="formData.isFactoryDelivery" disabled>-->
                  <!--<el-radio label="Y"></el-radio>-->
                  <!--<el-radio label="N"></el-radio>-->
                <!--</el-radio-group>-->
              </el-form-item>
              <el-form-item  class="ww-input-dia"  label="物料替代品1代号：" prop="kaMaterielCodeReplace1">
                <el-input
                  suffix-icon="el-icon-tickets"
                  v-model="formData.kaMaterielCodeReplace1.code"
                  ref="kaMaterielCodeReplace1"
                  @focus="showDialog($event, 'kaMaterielCodeReplace1')"
                  readonly
                >
                  <i v-if="formData.kaMaterielCodeReplace1.code" class="el-icon-error"  slot="append" @click.stop.prevent="clear('kaMaterielCodeReplace1')"></i>
                </el-input>
                <!--<span v-show="formData.kaMaterielCodeReplace1.name" class="clear-btn-wrapper">-->
                  <!--<el-button type="primary" @click="clear('kaMaterielCodeReplace1')">清空</el-button>-->
                <!--</span>-->
              </el-form-item>
              <el-form-item label="物料替代品1名称：">
                <!--<el-input :disabled="!!ruleForm.id" v-model="ruleForm.prodNo" placeholder="达能物料编码" readonly></el-input>-->
                <span class="noBorderText">{{formData.kaMaterielCodeReplace1.name}}</span>
              </el-form-item>
              <el-form-item  class="ww-input-dia" label="物料替代品2代号：" prop="kaMaterielCodeReplace2">
                <el-input
                  suffix-icon="el-icon-tickets"
                  v-model="formData.kaMaterielCodeReplace2.code"
                  ref="kaMaterielCodeReplace2"
                  @focus="showDialog($event, 'kaMaterielCodeReplace2')"
                  readonly
                >
                  <i v-if="formData.kaMaterielCodeReplace2.code" class="el-icon-error"  slot="append" @click.stop.prevent="clear('kaMaterielCodeReplace2')"></i>
                </el-input>
                <!--<span v-show="formData.kaMaterielCodeReplace2.name" class="clear-btn-wrapper">-->
                  <!--<el-button type="primary" @click="clear('kaMaterielCodeReplace2')">清空</el-button>-->
                <!--</span>-->
              </el-form-item>
              <el-form-item label="物料替代品2名称：">
                <!--<el-input :disabled="!!ruleForm.id" v-model="ruleForm.prodNo" placeholder="达能物料编码" readonly></el-input>-->
                <span class="noBorderText">{{formData.kaMaterielCodeReplace2.name}}</span>
              </el-form-item>
              <el-form-item label="系统产品销售编码：" prop="systemProductSalesCode">
                <el-input v-model="formData.systemProductSalesCode"></el-input>
              </el-form-item>
              <!-- 4.17新增系统产品编码 -->
              <el-form-item label="系统产品编码：" prop="systemProductCode">
                <el-input v-model="formData.systemProductCode"></el-input>
              </el-form-item>
              <el-form-item label="系统产品名称：" prop="systemProductName">
                <el-input v-model="formData.systemProductName"></el-input>
              </el-form-item>
              <el-form-item label="最小单位箱转换系数：" prop="minBoxCoefficient">
                <el-input-number :min="1" :precision="0" v-model="formData.minBoxCoefficient"></el-input-number>
              </el-form-item>
              <el-form-item label="开单分类文本：">
                <el-input v-model="formData.billingClassifyText"></el-input>
              </el-form-item>
              <el-form-item label="备注：">
                <el-input v-model="formData.remarks"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <select-dialog
      :modal-title="'达能物料'"
      :dialog-visible="showDialogFlag"
      :data="data3"
      :default-props="defaultProps"
      @confirm-select-item="setSelectItem"
      @cancel="cancel"
    ></select-dialog>
  </div>
</template>
<script>
import formHeader from "../components/form-header";
import commonMixin from "@/mixins/common.js";
import {
  systemCompany,
  getGroupNumber,
  methodPost
} from "../../api/request.js";
import selectDialog from "../components/select-dialog.vue";
const isNumber = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('不能为空'));
  }
  try {
    value -= 0;
  } catch (e) {
    callback(new Error('请输入数字值'));
  }
  if (!Number.isInteger(value)) {
    callback(new Error('请输入整数数字'));
  } if (value < 1) {
    callback(new Error('系数不能为小于1'));
  } else {
    callback();
  }
};

export default {
  name: "ProductMatchingList",
  components: { selectDialog, formHeader },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!this.formData.systemItem) {
        callback(new Error("请先选择系统"));
      } else {
        callback();
      }
    };
    var validatePass1 = (rule, value, callback) => {
      if (!this.formData.kaMaterielCode) {
        callback(new Error("请先选择达能物料"));
      } else {
        if (rule.field === "kaMaterielCodeReplace1") {
          console.log(this.formData)
          if (
            this.formData.kaMaterielCodeReplace1.code ===
            this.formData.kaMaterielCode.code
          ) {
            callback(new Error("达能物料替代品1与达能物料重复"));
          } else if (
            this.formData.kaMaterielCodeReplace2 && this.formData.kaMaterielCodeReplace2.code &&
            this.formData.kaMaterielCodeReplace1.code ===
            this.formData.kaMaterielCodeReplace2.code
          ) {
            callback(new Error("达能物料替代品1与达能物料替代品2重复"));
          } else {
            callback();
          }
        } else if (rule.field === "kaMaterielCodeReplace2") {
          if (
            this.formData.kaMaterielCodeReplace2.code ===
            this.formData.kaMaterielCode.code
          ) {
            callback(new Error("达能物料替代品2与达能物料重复"));
          } else if (
            this.formData.kaMaterielCodeReplace1 && this.formData.kaMaterielCodeReplace1.code &&
            this.formData.kaMaterielCodeReplace2.code ===
            this.formData.kaMaterielCodeReplace1.code
          ) {
            callback(new Error("达能物料替代品2与达能物料替代品1重复"));
          } else {
            callback();
          }
        }
      }
    };
    return {
      isGetData: false,
      isUpdate: false,
      title: "",
      formData: {
        systemItem: "",
        groupNumber: "",
        kaMaterielCode: "", // 达能物料代号
        productBigClassName: "", // 产品大类名称
        productBigClassCode: "", // 产品大类代号
        shelfLifeDay: "", // 保质期天数
        isCoSale: "", // 是否共卖品项
        isFactoryDelivery: "", // 是否工厂代发货品项
        kaMaterielCodeReplace1: "", // 达能物料替代品1
        kaMaterielCodeReplace2: "", // 达能物料替代品2
        systemProductSalesCode: "", // 系统销售产品编码
        systemProductCode: "", // 系统产品编码
        systemProductName: "", // 系统产品名称
        minBoxCoefficient: "", // 最小单位换箱系数
        billingClassifyText: "", // spa开单分类文本
        remarks: "" // 备注
      },
      groupNumberGroup: [],
      branchOffice: [],
      wwRules: [
        { validator: validatePass, trigger: "blur" },
        { validator: validatePass1, trigger: "blur" }
      ],
      rules: {
        groupNumber: [
          {
            required: true,
            message: "此项为必填项",
            trigger: "blur"
          }
        ],
        systemItem: [
          {
            required: true,
            message: "此项为必填项",
            trigger: "blur"
          }
        ],
        kaMaterielCode: [
          { validator: validatePass, trigger: "blur" },
          {
            required: true,
            message: "此项为必填项"
          }
        ],
        kaMaterielCodeReplace1: [
          { validator: validatePass, trigger: "blur" },
          { validator: validatePass1, trigger: "blur" }
        ],
        kaMaterielCodeReplace2: [
          { validator: validatePass, trigger: "blur" },
          { validator: validatePass1, trigger: "blur" }
        ],
        systemProductSalesCode: [
          {
            required: true,
            message: "此项为必填项",
            trigger: "blur"
          }
        ],
        // systemProductCode:[
        //   { required: true, message: "", trigger: "blur" }
        // ],
        systemProductName: [
          { required: true, message: "此项为必填项", trigger: "blur" }
        ],
        minBoxCoefficient: [{
          required: true,
          message: "此项为必填项",
          trigger: "blur"
        },
        { validator: isNumber, trigger: 'blur' }]
      },
      data2: [],
      data3: [],
      showDialogFlag: false,
      defaultProps: {
        children: "childrenList",
        label: "name",
        searchName: ["name", "code"]
      }
    };
  },
  watch: {
    "formData.systemItem": {
      handler() {
        if (this.isUpdate) return;
        this.data3 = [];
        this.formData.kaMaterielCode = "";
        this.formData.kaMaterielCodeReplace1 = "";
        this.formData.kaMaterielCodeReplace2 = "";
      },
      deep: true
    },
    "formData.kaMaterielCodeReplace1": {
      handler() {
        this.$refs.ruleForm && this.$refs.ruleForm.validateField('kaMaterielCodeReplace1', valid => {
          if (valid) {
            console.log('验证通过')
          }
        });
      },
      deep: true
    },
    "formData.kaMaterielCodeReplace2": {
      handler() {
        this.$refs.ruleForm && this.$refs.ruleForm.validateField('kaMaterielCodeReplace2', valid => {
          if (valid) {
            console.log('验证通过')
          }
        });
      },
      deep: true
    }
  },
  mixins: [commonMixin],
  created() {
    // this.init();
    if (this.$route.query.method === "update") {
      this.title = "编辑可销产品匹配清单";
      this.isUpdate = true;
      methodPost(
        "/marketableProducts/toEditMatchingDetail?id=" + this.$route.query.id,
        {}
      ).then(res => {
        if (res.code === 0) {
          var data = res.data;
          console.log(data);
          this.formData = {
            systemItem: {
              name: data.systemCode + ' ' + data.systemName,
              code: data.systemCode
            },
            groupNumber: data.groupNumber,
            kaMaterielCode: {
              codeName: (data.kaMaterielCode || '') + ' ' + (data.kaMaterielName || ''),
              name: data.kaMaterielName || '',
              code: data.kaMaterielCode
            },
            productBigClassName: data.prodTypeName,
            productBigClassCode: data.prodTypeCode,
            shelfLifeDay: data.shelfLifeDay,
            kaMaterielCodeReplace1: {
              codeName: (data.kaMaterielCodeReplace1 || '') + ' ' + (data.kaMaterielNameReplace1 || ''),
              code: data.kaMaterielCodeReplace1,
              name: (data.kaMaterielNameReplace1 || '')
            },
            kaMaterielCodeReplace2: {
              code: data.kaMaterielCodeReplace2,
              name: (data.kaMaterielNameReplace2 || ''),
              codeName: (data.kaMaterielCodeReplace2 || '') + ' ' + (data.kaMaterielNameReplace2 || '')

            },
            isFactoryDelivery: data.isFactoryDelivery,
            isCoSale: data.isCoSale,
            systemProductSalesCode: data.systemProductSalesCode,
            systemProductCode: data.systemProductCode,
            systemProductName: data.systemProductName,
            minBoxCoefficient: data.minBoxCoefficient,
            remarks: data.remarks ? data.remarks : "",
            billingClassifyText: data.billingClassifyText
              ? data.billingClassifyText
              : ""
          };
          this.isGetData = true;
        }
      });
    } else {
      // 新增
      this.isGetData = true;
      this.title = "新增可销产品匹配清单";
      this.getSystemList();
    }
  },
  methods: {
    selectSortBlur() {
      if (!this.formData.groupNumber) {
        this.$refs.ruleForm.validateField(['groupNumber'])
      } else {
        this.$refs.ruleForm.clearValidate(['groupNumber'])
      }
    },
    blur(val) {
      // this.$refs.ruleForm.validateField(['systemItem']);
      this.fieldsToValidate('systemItem')
      this.$refs.ruleForm.clearValidate(['kaMaterielCode', 'kaMaterielCodeReplace1', 'kaMaterielCodeReplace2'])
    },
    fieldsToValidate(val) {
      const fieldsToValidate = [val];
      const _self = this;
      Promise.all(fieldsToValidate.map(item => {
        const p = new Promise(function(resolve, reject) {
          _self.$refs['ruleForm'].validateField(item, (error) => {
            resolve(error)
          })
        });
        return p;
      })).then((data) => {
        console.info(data)
      })
    },
    // 获取系统列表
    getSystemList() {
      systemCompany("/bill/findSysBillSampleList").then(res => {
        if (res.code === 0) {
          this.branchOffice = res.data;
        }
      });
    },
    // 获取匹配组号
    getGroupNumberList(systemItem) {
      this.formData.groupNumber = "";
      this.formData.productBigClassCode = "";
      this.formData.productBigClassName = "";
      this.formData.shelfLifeDay = "";
      this.formData.isCoSale = "";
      this.formData.productBigClassCode = "";
      this.formData.isFactoryDelivery = "";
      const params = { systemCode: systemItem.code };
      getGroupNumber("/marketableProducts/findGroupNumberList", params).then(
        res => {
          if (res.code === 0) {
            this.groupNumberGroup = res.data;
          }
        }
      );
      this.fieldsToValidate('systemItem')
      this.$refs.ruleForm.clearValidate(['kaMaterielCode', 'kaMaterielCodeReplace1', 'kaMaterielCodeReplace2'])
    },
    // 获取系统物料
    getWuLiaoList() {
      var _this = this;
      var obj = {
        systemCode: _this.formData.systemItem.code
      };
      methodPost("/material/findMaterialTreeList", obj).then(res => {
        if (res.code === 0) {
          this.data3 = res.data;
        }
      });
    },
    // 出现弹框里边的方法
    setSelectItem(val) {
      if (val && val.data) {
        val['data'] = JSON.parse(JSON.stringify(val.data))
        val.data['codeName'] = val.data['code'] + ' ' + val.data['name']
      }
      this.formData[this.focusInput] = val.data || '';
      if (this.focusInput === "kaMaterielCode") {
        this.formData.shelfLifeDay = val.data.shelfLifeNum
          ? val.data.shelfLifeNum
          : 0;
        this.formData.productBigClassName = val.parent.parent.data.name;
        this.formData.productBigClassCode = val.parent.parent.data.code;

        this.formData.isFactoryDelivery = val.data.isFactoryBrandItem
          ? val.data.isFactoryBrandItem
          : "";
        this.formData.isCoSale = val.data.isPublicBrandItem
          ? val.data.isPublicBrandItem
          : "";
        if (this.isUpdate) {
          return;
        }
        this.$refs.ruleForm.clearValidate(['kaMaterielCodeReplace1', 'kaMaterielCodeReplace2'])
      }
      this.showDialogFlag = false;
    },
    clear(type) {
      this.formData[type] = "";
      switch (type) {
        case "kaMaterielCode":
          this.formData.shelfLifeDay = "";
          this.formData.productBigClassName = "";
          this.formData.isFactoryDelivery = "";
          this.formData.isCoSale = "";
          this.formData.productBigClassCode = "";
          break;
      }
    },
    // 关闭弹框
    cancel() {
      this.showDialogFlag = false;
    },
    // 显示弹框
    showDialog(e, val) {
      if (!this.formData.systemItem) {
        e.target.blur();
        return;
      }
      if (val !== "kaMaterielCode") {
        if (!this.formData.kaMaterielCode) {
          e.target.blur();
          return;
        }
      }
      if (this.data3.length === 0) {
        this.getWuLiaoList();
      }
      this.focusInput = val;
      this.showDialogFlag = true;
    },
    save() {
      if (document.getElementsByClassName('el-form-item__error').length) {
        return;
      }
      this.$refs.ruleForm.validate(valid => {
        this.$refs.ruleForm.clearValidate(['kaMaterielCodeReplace1', 'kaMaterielCodeReplace2'])
        if (valid) {
          const _this = this;
          let url;
          let saveFormData;
          if (this.isUpdate) {
            url = "/marketableProducts/modifyMatchingDetail";
            saveFormData = {
              id: _this.$route.query.id,
              kaMaterielCodeReplace1:
                _this.formData.kaMaterielCodeReplace1.code || '',
              kaMaterielNameReplace1:
                _this.formData.kaMaterielCodeReplace1.name || '',
              kaMaterielCodeReplace2:
                _this.formData.kaMaterielCodeReplace2.code || '',
              kaMaterielNameReplace2:
                _this.formData.kaMaterielCodeReplace2.name || '',
              minBoxCoefficient: _this.formData.minBoxCoefficient,
              productBigClassName: _this.formData.productBigClassName,
              billingClassifyText: _this.formData.billingClassifyText,
              remarks: _this.formData.remarks,
              systemCode: _this.formData.systemItem.code,
              systemName: _this.formData.systemItem.name,
              systemProductCode: _this.formData.systemProductCode,
              systemProductName: _this.formData.systemProductName,
              systemProductSalesCode: _this.formData.systemProductSalesCode
            };
          } else {
            url = "/marketableProducts/saveMatchingDetail";
            saveFormData = {
              sysId: _this.formData.systemItem.id,
              groupNumber: _this.formData.groupNumber,
              kaMaterielCode: _this.formData.kaMaterielCode.code,
              kaMaterielCodeReplace1:
                _this.formData.kaMaterielCodeReplace1.code,
              kaMaterielNameReplace1:
                _this.formData.kaMaterielCodeReplace1.name,
              kaMaterielCodeReplace2:
                _this.formData.kaMaterielCodeReplace2.code,
              kaMaterielNameReplace2:
                _this.formData.kaMaterielCodeReplace2.name,
              kaMaterielName: _this.formData.kaMaterielCode.name,
              minBoxCoefficient: _this.formData.minBoxCoefficient,
              productBigClassName: _this.formData.productBigClassName,
              billingClassifyText: _this.formData.billingClassifyText,
              remarks: _this.formData.remarks,
              shelfLifeDay: _this.formData.shelfLifeDay,
              systemCode: _this.formData.systemItem.code,
              systemName: _this.formData.systemItem.name,
              systemProductCode: _this.formData.systemProductCode,
              systemProductName: _this.formData.systemProductName,
              systemProductSalesCode: _this.formData.systemProductSalesCode
            };
          }
          console.log(saveFormData);
          methodPost(url, saveFormData).then(res => {
            console.log(res);
            if (res.code === 0) {
              this.$message.success("保存成功");
              this._gobackRefresh(this, this.$route.fullPath);
            } else {
              this.$message.error(res.message || "保存出错，请稍后再试");
            }
          });
        } else {
          return false;
        }
      });
    },
    back() {
      const path =
        "/config/%2Ftemplate%2Fmodule%2Fwantwant%2Fmarketable_products_matching_detail_list.json";
      // this.goBack(path);
      this._gobackRefresh(this, this.$route.fullPath, path)
    }
  }
};
</script>
<style type="text/scss" lang="scss" scoped>
.rolemanage {
  display: flex;
  padding: 10px;
  .card {
    flex: 1;
    min-width: 800px;
    display: inline-block;
    .cangbieItem {
      padding: 10px;
      .el-form {
        // border-bottom: 1px solid #eee;
        // box-sizing: border-box;
        /*display: flex;*/
        /*flex-direction: column;*/
        /*flex-wrap: wrap;*/
        .el-form-item {
          /*max-width: 300px;*/
          /*display: flex;*/
          /*text-align: left;*/
          /*.el-form-item__label {*/
            /*width: 180px;*/
            /*text-align: left;*/
            /*padding-right: 5px;*/
          /*}*/
          /*.el-input,*/
          /*.el-textarea {*/
            /*// display: inline-block;*/
          /*}*/
        }
      }
    }
    .upload-pr {
      position: relative;
    }
    .upload-tip {
      position: absolute;
      bottom: 20px;
      left: 320px;
      font-size: 12px;
      color: #999;
    }
    .wx-img {
      width: 85px;
      height: 85px;
      overflow: hidden;
      background: #ccc;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 85px;
  height: 85px;
  line-height: 85px;
  text-align: center;
}
.avatar {
  width: 85px;
  height: 85px;
  display: block;
}
.add {
  margin: 20px 0 0 130px;
}
</style>
<style>
.avatar-uploader .el-upload:hover {
  border-color: #dca864;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader.noBorder .el-upload {
  border: 1px dashed #fff;
}
.timepicker .el-form-item__content {
  width: 240px;
}
.timepicker .el-input--suffix .el-input__inner {
  padding-right: 6px;
}
.otherWidth .el-form-item__content {
  width: 300px;
}
.clear-btn-wrapper {
  position: absolute;
  top: 0;
  right: -74px;
}
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/productMatchingList/index.vue